// CDN resource not used in testing, so load it here
// if (typeof firebase === `undefined`) {
//   window.firebase = require(`firebase`)
// }

import { isProduction } from './helpers'

const dbConfig = {
  apiKey: `AIzaSyAwfJ_XyGkLOAEQUZub7wLU8lQ1vWq4w4c`,
  authDomain: `battlefx2.firebaseapp.com`,
  databaseURL: `https://battlefx2.firebaseio.com`,
  projectId: `battlefx2`,
  storageBucket: `battlefx2.appspot.com`,
  messagingSenderId: `342171314532`,
}

const testDbConfig = {
  apiKey: `AIzaSyABzDlBhz6qLsi94vTfejAJmA0k_BPovEs`,
  authDomain: `battlefx-testing.firebaseapp.com`,
  databaseURL: `https://battlefx-testing.firebaseio.com`,
  projectId: `battlefx-testing`,
  storageBucket: `battlefx-testing.appspot.com`,
  messagingSenderId: `680144880208`,
}

const config = !isProduction() ? testDbConfig : dbConfig

// Initialize Firebase
const fb = firebase.initializeApp(config)

export const db = fb.database()

export default fb
